import { Loader } from 'ui/components/primitives';
import { LoaderSummary } from './Summary.components.styles';

type LoaderProps = {
  message: string;
};

const LoaderBase = ({ message }: LoaderProps) => (
  <LoaderSummary.Component marginTop="sp-10">
    <Loader />
    <LoaderSummary.Text level={6}>{message}</LoaderSummary.Text>
  </LoaderSummary.Component>
);

export default LoaderBase;
